// extracted by mini-css-extract-plugin
export default {"exercise__button":"exercise_exercise__button__lXjMt"};